// Auth
export const SIGN_IN_ADMIN = 'SIGN_IN_ADMIN'
export const SIGN_OUT_ADMIN = 'SIGN_OUT_ADMIN'

export const ADMIN_COMPANY = 'ADMIN_COMPANY'
export const ADMIN_COMPANY_QUERY = 'ADMIN_COMPANY_QUERY'

export const ADMIN_ANNOUNCEMENT = 'ADMIN_ANNOUNCEMENT'
export const ADMIN_ANNOUNCEMENT_QUERY = 'ADMIN_ANNOUNCEMENT_QUERY'